import React from 'react'
import ModalGeneric from '../ModalGeneric'

import { ReactComponent as NpsExplanationImage } from 'static/svg/nps-explanation.svg'

import { Container, Image, Text } from './styles'

interface NpsHelpModalProps {
  onClose: () => void
}

export const NpsHelpModal: React.FC<NpsHelpModalProps> = ({ onClose }: NpsHelpModalProps) => {
  return (
    <ModalGeneric
      modalTitle='O que é NPS e como é calculado?'
      hasButton
      btnText='ENTENDI'
      onCloseModal={onClose}
      btnOnClick={onClose}
    >
      <Container>
        <Text variant='content2'>
          <>
            O NPS <i>(Net Promoter Score)</i> é uma metodologia criada por Fred Reichheld, em 2003, para medir a satisfação do cliente, de 0 a 10. <br /> <br />
            Ao final da consulta, fazemos algumas perguntas para medir a satisfação do paciente - que pode ou não respondê-las, é opcional. Uma dessas perguntas é: <i>“O quanto você recomenda este profissional?”.</i><br /> <br />  
            Como explica a imagem abaixo, o cálculo para chegar na nota NPS é igual a: <strong>nº promotores – nº detratores ÷ total de respondentes x 100.</strong>
          </>
        </Text>

        <Image>
          <NpsExplanationImage />
        </Image>

        <Text variant='content2'>
          <>
            Ou seja, subtrai-se a quantidade de promotores (que votaram 9 e 10) pela quantidade de detratores (que votaram de 0 a 6), 
            divide-se pelo número total de respondentes e multiplica-se por 100. Na metodologia NPS, as notas 7 e 8 são tidas como neutras, por isso não entram no cálculo. <br /> <br/> 
            Além de pacientes satisfeitos, uma nota NPS alta significa maior taxa de retorno em consultas.
          </>
        </Text>
           
      </Container>
    </ModalGeneric>
  )
}